/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CheckBoxConfig } from 'libs/sysque/shared/ui/src/lib/models/check-box-config';
import { SysqueNumberBoxVM } from 'libs/sysque/shared/ui/src/lib/models/sysque-number-box-vm';
import { Item } from 'libs/sysque/toolbelt/data-access/src/lib/domain/item';
import { SystemInfo } from 'libs/sysque/toolbelt/data-access/src/lib/domain/system-info';
import { TabDescription } from 'libs/sysque/toolbelt/data-access/src/lib/domain/tab-description';

export class SysqueElectricalState {
  [key: string]: any;
  systemList: SystemInfo[] = [];
  categoryList: TabDescription[] = [];
  fittingList: Item[] = [];
  selectedCategory: string = '';
  selectedSystem: string = '';
  checkBoxConfigs: CheckBoxConfig[] = [];
  isHangerNeeded = false;
  isCableTrayClearanceNeeded = false;
  showCategoryList = false;
  showAddFittingBtn = false;
  onlyFittingProcess = false;
  processingEnabled: any;
  showNonStandard: any;
  cableTrayNumberText:SysqueNumberBoxVM[]=[];
  projectName: string = '';
  projectAndPanelName: string[] = [];
  wirefillSpec: string = '';
  panelName: string = '';
  releaseVersion: string = '';
  isLicenseValid: boolean = false;
}
